import React from 'react';
import {injectIntl} from "react-intl";
import {Popover} from "antd";
import connect from "react-redux/es/connect/connect";

class SAInfoBubble extends React.Component {

  render() {

    const {brand='bmw'} = this.props;
    const className = `icon-${brand}`


    return (
      <Popover {...this.props}>
        <span>
          <svg className={`bmw-icon ${className}`}>
            <use xlinkHref="#icon-info"/>
          </svg>
        </span>

      </Popover>
    )
  }
}

const mapDispatchToProps = dispatch => ({
});

const mapStateToProps = state => ({
  brand: state.publicContext && state.publicContext.brand,
});

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SAInfoBubble)
);



// WEBPACK FOOTER //
// ./src/components/common/confirmation/SAInfoBubble.js